export const lightColorPalette = {
  background: "#FFFFFF",
  backgroundTint: "#FEFDFF",
  backgroundTintAlternative: "#FBFCFD",
  foreground: "#00071B",

  greyPrimary: "#5F6368",
  greySecondary: "#D9D9D9",
  greyTertiary: "#F5F4F9",
  greyQuaternary: "#D7D4E3",
  greyQuinary: "#F5F4F9",
  greySenary: "#AEAEAE",
  greySeptenary: "#F5F4F9AA",

  accent: "#007BFF",
  accentHover: "#0066CC",
  accentTint: "#007BFF1A",
  accentShade: "#003166",

  info: "#007BFF",
  infoHover: "#0066CC",
  infoTint: "#007BFF1A",
  infoShade: "#003166",

  positive: "#059C5F",
  positiveHover: "#047A4C",
  positiveTint: "#059C5F1A",
  positiveShade: "#00321E",

  warning: "#FFB800",
  warningHover: "#CC9300",
  warningTint: "#FFB8001A",
  warningShade: "#664900",

  negative: "#F14242",
  negativeHover: "#C13535",
  negativeTint: "#F142421A",
  negativeShade: "#601A1A",

  gradientA: "#0E83FF",
  gradientB: "#C467D5",
  gradientC: "#FF6B6E",
  gradientD: "#FB9458",
};

export const darkColorPalette: typeof lightColorPalette = {
  background: "#0A0A0A",
  backgroundTint: "#161616CC",
  backgroundTintAlternative: "#1A1A1A",
  foreground: "#FFFFFF",

  greyPrimary: "#A8A8A8",
  greySecondary: "#404040",
  greyTertiary: "#1A1A1A",
  greyQuaternary: "#404040",
  greyQuinary: "#1A1A1A",
  greySenary: "#4D4D4D",
  greySeptenary: "#1A1A1AAA",

  accent: "#007BFF",
  accentHover: "#0066CC",
  accentTint: "#007BFF1A",
  accentShade: "#003166",

  info: "#007BFF",
  infoHover: "#0066CC",
  infoTint: "#007BFF1A",
  infoShade: "#003166",

  positive: "#059C5F",
  positiveHover: "#047A4C",
  positiveTint: "#059C5F1A",
  positiveShade: "#00321E",

  warning: "#FFB800",
  warningHover: "#CC9300",
  warningTint: "#FFB8001A",
  warningShade: "#664900",

  negative: "#F14242",
  negativeHover: "#C13535",
  negativeTint: "#F142421A",
  negativeShade: "#601A1A",

  gradientA: "#0E83FF",
  gradientB: "#C467D5",
  gradientC: "#FF6B6E",
  gradientD: "#FB9458",
};
